<template>
    <div class="vmodal-bg">
        <div class="vmodal">
            <header class="vmodal-header">
                <slot name="header">
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="cancel"
                        aria-label="Close modal"
                    ><i class="icon-remove"></i></button>
                </slot>
            </header>

            <section class="vmodal-body">
                <slot name="default">Are you sure?</slot>
            </section>

            <footer class="vmodal-footer">
                <slot name="footer">
                    <button class="btn" :class="buttonClass"
                        @click="confirm">{{buttonLabel}}</button>
                    <button class="btn"
                        @click="cancel">Cancel</button>
                </slot>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalConfirm",
        props: {
            buttonClass: {
                type: String,
                default: 'btn-primary'
            },
            buttonLabel: {
                type: String,
                default: 'Confirm'
            },
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            confirm() {
                this.$emit('confirm');
            },
        },
    }
</script>

<style>
.vmodal-bg {
    z-index: 1000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}
.vmodal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border: 1px solid #eeeeee;
    border-radius: 4px;
    padding: 15px;
    width: 300px;
}
.vmodal-header {
    display: flex;
    justify-content: flex-end;
}
.vmodal-body {
    padding: 10px 0;
}
.vmodal-footer {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #eeeeee;
    padding-top: 10px;
}
.vmodal-footer button {
    margin-left: 5px;
}
</style>